<!-- FOLLOW FORM -->
<div id="followEmailHolder">
    <div id="followEmail">
		<a href="#" class="js-follow-email-close">
			<svg class="icon icon-delete"><use xlink:href="/images/icon/icon-junior.svg#icon-delete"></use></svg>
		</a>
		<form class="form-redux" name="followEmailForm" id="followEmailForm" method="post" action="{{secureBaseURL}}common/mmi_update.html" target="followIframe">
			<input type="hidden" name="callback" value="followStatus" />
			<input type="hidden" name="postMessage" value="parent.postMessage" />

			<input type="hidden" name="challengeId" value="{{#if followChallengeId}}{{followChallengeId}}{{/if}}" />
			<input type="hidden" name="teacherId" value="{{#if followTeacherId}}{{followTeacherId}}{{/if}}" />
			<input type="hidden" name="schoolId" value="{{#if followSchoolId}}{{followSchoolId}}{{/if}}" />
			<input type="hidden" name="searchURL" value="{{#if followURL}}{{followURL}}{{/if}}" />
			<input type="hidden" name="followAbout" value="{{#if followAbout}}{{followAbout}}{{/if}}" />
			<input type="hidden" name="remove" value="false" />

			<input type="hidden" name="id" value="{{bestQueryStringParam 'id' 'donorId'}}" />
			<input type="hidden" name="verify" value="{{queryStringParam 'verify'}}" />

			<label for="followEmailInput" id="followEmailMessage">Save your Favorites:</label>
			<div class="input-holder">
				<input id="followEmailInput" type="email" name="email" disabled  autocomplete="off" />
				<input class="button-secondary small js-follow-email-submit" type="submit" name="followSubmit" value="submit" />
			</div>
		</form>
    </div>  
</div>
